import React, { useEffect, useState } from "react";
import { LatestUpdate } from "./calendar/LatestUpdatesPanel";
import { useNavigate } from "react-router-dom";
import ImpactAssessment from "./ImpactAssessment";
import TruncatedNameWithTooltip from "@shared/components/TruncatedNameWithTooltip";

interface UpdateDetailsModalProps {
  selectedUpdate: LatestUpdate;
  isOpen: boolean;
  onClose: () => void;
  refreshProgramData: () => void;
}

const UpdateDetailsModal: React.FC<UpdateDetailsModalProps> = ({
  selectedUpdate,
  isOpen,
  onClose,
  refreshProgramData,
}) => {
  const navigate = useNavigate();

  const [shouldRefresh, setShouldRefresh] = useState(false);

  const onGoToReport = () => {
    navigate(
      `/report/${selectedUpdate.report_id}/project/${selectedUpdate.project_id}`
    );
    onClose();
  };

  useEffect(() => {
    if (!isOpen && shouldRefresh) {
      setTimeout(() => {
        refreshProgramData();
      }, 250);
      setShouldRefresh(false);
    }
  }, [isOpen, shouldRefresh]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg max-w-xl 2xl:max-w-3xl w-full py-6 relative max-h-[90vh] overflow-auto scrollbar-hide 2xl:max-h-[85vh]">
        <h2 className="text-base 2xl:text-lg font-semibold text-gray-800 mb-4 border-b border-gray-300 pb-6 px-8 m-0">
          <TruncatedNameWithTooltip
            name={selectedUpdate.title}
            widthClass="max-w-xl 2xl:max-w-3xl"
            textClass="text-base 2xl:text-lg"
            tooltipPlacement="top"
          />
          {/* {selectedUpdate.title} */}
        </h2>

        <div className="overflow-auto scrollbar-hide flex flex-col">
          <div className="mx-8 border text-sm 2xl:text-base border-gray-300 p-4 mb-4 flex-1">
            {selectedUpdate.description}
          </div>

          <ImpactAssessment
            updateId={selectedUpdate?.id}
            setShouldRefresh={setShouldRefresh}
          />
        </div>
        <div className="flex justify-end space-x-2 px-6 border-t border-gray-300 pt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm 2xl:text-base rounded text-blue-600 border border-blue-600 hover:bg-blue-50"
          >
            Close
          </button>
          {selectedUpdate.report_id && selectedUpdate.project_id && (
            <button
              onClick={onGoToReport}
              className="px-4 py-2 text-sm 2xl:text-base rounded bg-blue-600 text-white hover:bg-blue-700"
            >
              Go to Report
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateDetailsModal;
